import React, { Fragment, useState, useCallback, useEffect } from 'react';
import { Button, CssBaseline, TextField, Link, Grid, Typography } from '@material-ui/core';
import { makeStyles, createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useCookies } from 'react-cookie';
import { useHistory } from 'react-router-dom';
import ToastStr from '../../request/toastStr';
import { Box, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, IconButton } from '@material-ui/core';

import axios from 'axios';

import { COLORS } from '../../shared/Theme';
import { SIcon } from '../../shared/Icon';

import { admin as v_admin, basic, Values, SNACKBAR_TIME, edu } from '../../request/values';

const SERVER = basic.server;

const useStyles = makeStyles((theme: any) => ({
	background: {
		position: 'absolute',
		top: 0,
		width: '100vw',
		height: '100vh',
		background: `url("/images/background.png")`,
	},
	container1: {
		padding: 0,
		height: '100vh',
		marginTop: '15vh',
	},
	container2: {
		padding: 0,
		height: '100vh',
		marginTop: '2vh',
	},
	playImage: {
		width: '50%',
	},
	playImageSection: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: '30vw', // Fix IE 11 issue.
		marginTop: theme.spacing(1),
	},
	logoSection: {
		display: 'flex',
		justifyContent: 'center',
		flex: 1,
		alignItems: 'flex-end',
		marginTop: '40vh',
		marginBottom: '10vh',
	},
	logobutton: {
		border: 'none',
		backgroundColor: 'transparent',
	},
	buttonFont: {
		color: `${COLORS.WHITE}`,
		fontSize: '2vw',
	},
	border: {
		borderWidth: 5,
		borderStyle: 'solid',
		borderColor: `#000000`,
		background: `${COLORS.WHITE}`,
		padding: '1vw',
		marginTop: '1vh',
	},
	inputTime: {
		borderColor: 'black',
		borderRadius: '10px',
		width: '8vw',
		height: '10vh',
		fontSize: '3vw',
		textAlign: 'center',
	},
	timeSection: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		fontSize: '3vw',
		marginTop: '15vh',
	},
	timerSection: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'column',
		fontSize: '3vw',
		marginBottom: '10vh',
	},
	rankingTimerSection: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'column',
		fontSize: '3vw',
		color: `${COLORS.WHITE}`,
		borderWidth: 5,
		borderStyle: 'solid',
		borderColor: `${COLORS.WATER_BLUE}`,
		backgroundColor: `${COLORS.WATER_BLUE}`,
		borderRadius: 25,
		padding: '10px',
		marginTop: '3vh',
	},
	playButton: {
		width: '10vw',
		height: 'auto',
		marginLeft: '5vw',
	},
	playButtonImage: {
		width: '100%',
	},
	inputSection: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		fontSize: '3vw',
		fontWeight: 'bold',
		fontFamily: 'NanumB',
	},
	timerFont: {
		fontSize: '3vw',
		fontWeight: 'bold',
		fontFamily: 'NanumB',
	},
	trophySection: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		marginBottom: 50,
	},
	ExceptWinner: {
		backgroundColor: `${COLORS.LIGHT_GREY}`,
		width: '10vh',
		height: '9vh',
		marginBottom: 17,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: 20.7,
		boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
		'& img': {
			width: '8vh',
			height: 'auto',
		},
	},
	Winner: {
		backgroundColor: `${COLORS.WATER_BLUE}`,
		width: '15vh',
		height: '13vh',
		marginRight: 60,
		marginLeft: 60,
		marginBottom: 17,

		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: 20.7,
		boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
		'& img': {
			width: '13vh',
			height: 'auto',
		},
	},
	tableHeader: {
		width: '100vw',
		height: 'auto',
		// backgroundColor: `${COLORS.PUMPKIN}`,
		// background: `url("/images/ranking/header.webp")`,
		// objectFit: 'contain',
		// borderRadius: 10,
		// boxShadow: '1px 3px 6px 1px rgba(0, 0, 0, 0.16)',
	},
	tableHeaderRow: {
		width: '90vw',
		height: '5vh',
		// backgroundColor: `${COLORS.WATER_BLUE}`,
		borderRadius: 10,
		boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
	},
	headerCell: {
		fontSize: '1.3vw',
		// borderRadius: 10,
		// boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
		// backgroundColor: `${COLORS.WATER_BLUE}`,
	},

	tableContent: {
		height: 80,
		borderBottom: 'none',
		fontSize: '1.7vh',
		fontFamily: 'NanumB',
	},
	winnerContent: {
		'& th, td': {
			color: `${COLORS.WATER_BLUE}`,
		},
	},
	footer: {
		marginTop: 100,
		textAlign: 'center',
		paddingBottom: '10vh',
		'& img': {
			width: 166,
		},
	},
	playStartUpLogoSection: {
		display: 'flex',
		justifyContent: 'center',
		flex: 1,
		alignItems: 'flex-end',
		marginBottom: '10vh',
		marginRight: '-11vw',
		'& img': {
			width: '25vw',
			height: 'auto',
		},
	},
	upperSection: {
		display: 'flex',
	},
	infoButton: {
		borderWidth: 2,
		borderStyle: 'solid',
		borderColor: `${COLORS.CHARCHOAL_GREY}`,
		backgroundColor: `${COLORS.WATER_BLUE}`,
		borderRadius: '10px',
		margin: '0.5vh',
		width: '30vw',
	},
	endingSection: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
	},
	endingText: {
		fontSize: '3vw',
		fontWeight: 'bold',
		marginBottom: '10vw',
	},
}));

const HeadAdminClassRun: React.FC<any> = (props) => {
	const classes = useStyles();

	const [hours, setHours] = useState<any | null>();
	const [minutes, setMinutes] = useState<any | null>();
	const [seconds, setSeconds] = useState<any | null>();

	const [nowHours, setNowHours] = useState<any | null>();
	const [nowMin, setNowMin] = useState<any | null>();
	const [nowSec, setNowSec] = useState<any | null>();

	const [endHours, setEndHours] = useState<any | null>();
	const [endMin, setEndMin] = useState<any | null>();
	const [endSec, setEndSec] = useState<any | null>();

	let now = new Date();

	const [rank, setRank] = useState([
		{
			company_name: '테스트',
			stock: 180000,
			loan: 0,
			loan_interest: 0,
			capital: 180000,
			order_inventory: 0,
			used_mat: 0,
			license_stock: 10000,
		},
		{
			company_name: '테스트1',
			stock: 190000,
			loan: 0,
			loan_interest: 0,
			capital: 190000,
			order_inventory: 0,
			used_mat: 0,
			license_stock: 10000,
		},
		{
			company_name: '테스트2',
			stock: 200000,
			loan: 0,
			loan_interest: 0,
			capital: 200000,
			order_inventory: 0,
			used_mat: 0,
			license_stock: 10000,
		},
	]);

	const [timerFlag, setTimerFlag] = useState<any | null>(false);
	const history = useHistory();
	const { member } = props;

	const state: any = history.location.state;
	const classCode = state.code;
	const className = state.name;

	/*useEffect(() => {
      const countdown = setInterval(() => {
        if(timerFlag === true) {
          if (parseInt(seconds) > 0) {
              setSeconds(parseInt(seconds) - 1);
            }
            if (parseInt(seconds) === 0) {
              if (parseInt(minutes) === 0) {
                  if (parseInt(hours) === 0) {
                      clearInterval(countdown);
                  } else {
                    setHours(parseInt(hours) - 1);
                    setMinutes(59);
                    setSeconds(59);
                  }
              } else {
                setMinutes(parseInt(minutes) - 1);
                setSeconds(59);
              }
            }
        } 
      }, 1000);
      return () => clearInterval(countdown);
    }, [hours, minutes, seconds]);*/

	useEffect(() => {
		const countdown = setInterval(() => {
			setNowHours(now.getHours());
			setNowMin(now.getMinutes());
			setNowSec(now.getSeconds());

			let et = parseInt(endHours) * 3600 + parseInt(endMin) * 60 + parseInt(endSec);
			let nt = parseInt(nowHours) * 3600 + parseInt(nowMin) * 60 + parseInt(nowSec);
			let temp = et - nt;

			setHours(Math.floor(temp / 3600));
			temp = temp % 3600;
			setMinutes(Math.floor(temp / 60));
			temp = temp % 60;
			setSeconds(temp);
		}, 1000);
		return () => clearInterval(countdown);
	}, [nowHours, nowMin, nowSec]);

	const setEndTime = (event: any) => {
		let et = parseInt(endHours) * 3600 + parseInt(endMin) * 60 + parseInt(endSec);
		let nt = parseInt(nowHours) * 3600 + parseInt(nowMin) * 60 + parseInt(nowSec);
		let temp = et - nt;
		console.log(et + ' ' + nt);

		setHours(Math.floor(temp / 3600));
		temp = temp % 3600;
		setMinutes(Math.floor(temp / 60));
		temp = temp % 60;
		setSeconds(temp);

		setTimerFlag(true);
	};

	const valueChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { id, value } = e.target;

		const values = value.replace(/[^0-9]/g, '');

		if (id == 'hours') {
			setEndHours(values);
			setEndSec(0);
		} else if (id == 'minutes') {
			setEndMin(values);
			setEndSec(0);
		}
	};

	const AddComma = (num: number) => {
		var regexp = /\B(?=(\d{3})+(?!\d))/g;
		return num.toString().replace(regexp, ',');
	};

	const getRankContent = () => {
		axios({
			method: 'POST',
			data: {
				class_code: classCode,
			},
			withCredentials: true,
			url: SERVER + edu.path + edu.class_rank_content,
		})
			.then((res) => {
				return res.data;
			})
			.then((data: any) => {
				console.log('data?', data);
				if (data.code == Values.SUCCESS_CODE) {
					setRank(data.rank);
				} else {
				}
			});
	};

	useEffect(() => {
		getRankContent();
		console.log('ehllo');
		const tick = setInterval(() => {
			getRankContent();
		}, 1000 * 15);
		return () => clearTimeout(tick);
	}, []);

	const movePage = () => {
		history.push({
			pathname: '/headAdminOpenRanking',
			state: {
				// location state
				code: classCode,
				name: className,
			},
		});
	};

	if (hours <= 0 && minutes <= 0 && seconds <= 0 && timerFlag === true) {
		return (
			<div className={classes.background}>
				<Container component="main" className={classes.container1}>
					<CssBaseline />
					<div className={classes.endingSection}>
						<Typography className={classes.endingText}>플레이스타트업이 종료되었습니다!</Typography>
						<Button onClick={(e) => movePage()} className={classes.infoButton}>
							<Typography className={classes.buttonFont}>순위 공개</Typography>
						</Button>
					</div>
					<div className={classes.logoSection}>
						<SIcon type="P" />
					</div>
				</Container>
			</div>
		);
	} else if (hours != null && minutes != null && seconds != null && timerFlag === true) {
		if (hours == 0 && minutes < 10) {
			return (
				<div className={classes.background}>
					<Container component="main" className={classes.container2}>
						<CssBaseline />
						<div className={classes.timerSection}>
							<Typography className={classes.timerFont}>남은 시간</Typography>
							<Typography className={classes.timerFont}>
								{hours}:{minutes < 10 ? `0${minutes}` : minutes}:{seconds < 10 ? `0${seconds}` : seconds}
							</Typography>
						</div>
						<div className={classes.playImageSection}>
							<img className={classes.playImage} src="/images/playImage.png" />
						</div>
						<div className={classes.logoSection}>
							<SIcon type="P" />
						</div>
					</Container>
				</div>
			);
		} else {
			return (
				<div className={classes.background}>
					<Container component="main" className={classes.container2}>
						<CssBaseline />
						<div className={classes.upperSection}>
							<div className={classes.playStartUpLogoSection}>
								<img src="/images/ranking/logo.webp" />
							</div>
							<div className={classes.rankingTimerSection}>
								<Typography className={classes.timerFont}>남은 시간</Typography>
								<Typography className={classes.timerFont}>
									{hours}:{minutes < 10 ? `0${minutes}` : minutes}:{seconds < 10 ? `0${seconds}` : seconds}
								</Typography>
							</div>
						</div>

						<div className={classes.trophySection}>
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									textAlign: 'center',
								}}
							>
								<Box className={classes.ExceptWinner}>
									<img src="/images/ranking/silver.webp" />
								</Box>
								<Typography style={{ fontSize: '1.6vh' }}>{rank[1] != undefined ? rank[1].company_name : ''}</Typography>
							</div>
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									textAlign: 'center',
								}}
							>
								<Box className={classes.Winner}>
									<img src="/images/ranking/gold.webp" />
								</Box>
								<Typography style={{ fontSize: '2.5vh' }}>{rank[0] != undefined ? rank[0].company_name : ''}</Typography>
							</div>
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									textAlign: 'center',
								}}
							>
								<Box className={classes.ExceptWinner}>
									<img src="/images/ranking/bronze.webp" />
								</Box>
								<Typography style={{ fontSize: '1.6vh' }}>{rank[2] != undefined ? rank[2].company_name : ''}</Typography>
							</div>
						</div>

						<TableContainer
							component={Paper}
							style={{
								backgroundColor: `transparent`,
								// borderRadius: 10,
								boxShadow: 'none',
							}}
						>
							<Table size="small" aria-label="a dense table">
								<TableHead className={classes.tableHeader}>
									<TableRow className={classes.tableHeaderRow}>
										<TableCell width="10%" align="center" className={classes.headerCell}>
											순위
										</TableCell>
										<TableCell width="24.7%" align="center" className={classes.headerCell}>
											기업명
										</TableCell>
										<TableCell width="7%" align="center" className={classes.headerCell}>
											자산
										</TableCell>
										<TableCell width="5%" align="center" className={classes.headerCell}>
											-
										</TableCell>
										<TableCell width="7%" align="center" className={classes.headerCell}>
											부채
										</TableCell>
										<TableCell width="5%" align="center" className={classes.headerCell}>
											=
										</TableCell>
										<TableCell width="7%" align="center" className={classes.headerCell}>
											자본
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{rank.length != 0 &&
										rank.map((row, index) => (
											<TableRow
												key={row.company_name}
												className={index == 0 ? classes.winnerContent : ''}
												// sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
											>
												<TableCell width="10%" component="th" scope="row" align="center" className={classes.tableContent}>
													{`${index + 1}위`}
												</TableCell>
												<TableCell width="15vw" align="center" className={classes.tableContent}>
													{row.company_name}
												</TableCell>
												<TableCell width="7%" align="center" className={classes.tableContent}>
													{AddComma(row.stock + row.order_inventory - row.used_mat + row.license_stock) + '원'}
												</TableCell>
												<TableCell width="5%" align="center" className={classes.tableContent}></TableCell>
												<TableCell width="7%" align="center" className={classes.tableContent}>
													{AddComma(row.loan + row.loan_interest) + '원'}
												</TableCell>
												<TableCell width="5%" align="center" className={classes.tableContent}></TableCell>
												<TableCell width="7%" align="center" className={classes.tableContent}>
													{AddComma(row.capital + row.license_stock) + '원'}
												</TableCell>
											</TableRow>
										))}
								</TableBody>
							</Table>
						</TableContainer>

						<div className={classes.footer}>
							<img src="/images/youstarter.png" />
						</div>

						<div className={classes.logoSection}>
							<SIcon type="P" />
						</div>
					</Container>
				</div>
			);
		}
	} else {
		return (
			<div className={classes.background}>
				<Container component="main" className={classes.container1}>
					<CssBaseline />
					<div className={classes.inputSection}>
						플레이 종료 시각을 설정하세요
						<div className={classes.timeSection}>
							<input id="hours" className={classes.inputTime} onChange={valueChangeHandler} type="text"></input>:
							<input id="minutes" className={classes.inputTime} onChange={valueChangeHandler} type="text"></input>
							<Button fullWidth variant="contained" className={classes.playButton} onClick={(e) => setEndTime(e)}>
								<img className={classes.playButtonImage} src="/images/playButton.png" />
							</Button>
						</div>
					</div>
					<div className={classes.logoSection}>
						<SIcon type="P" />
					</div>
				</Container>
			</div>
		);
	}
};

export default HeadAdminClassRun;
